(function(){
    'use strict';
    angular.module('app').controller('UploadAttachmentModalController', UploadAttachmentModalController);

    UploadAttachmentModalController.$inject = [
        '$uibModalInstance',
        'ViewChangeNotificationFactory',
        'ConfirmationModalFactory',
        'attachment',
        'ComplianceService',
        'toastr',
        'complianceId',
        '$q',
        'ObjectHelpersService',
        'FormHelpersService'
    ];

    function UploadAttachmentModalController(
        $uibModalInstance,
        ViewChangeNotificationFactory,
        ConfirmationModalFactory,
        attachment,
        ComplianceService,
        toastr,
        complianceId,
        $q,
        ObjectHelpersService,
        FormHelpersService
    )  {
        const vm = this;
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        vm.onFileSelectHandler = onFileSelectHandler;
        vm.onSaveButtonClickHandler = onSaveButtonClickHandler;
        vm.onCancelButtonClickHandler = onCancelButtonClickHandler;
        vm.onAttachmentActiveStatusChangedHandler = onAttachmentActiveStatusChangedHandler;

        function onFileSelectHandler(file) {
            vm.attachment.file = file || vm.attachment.file;
            vm.attachment.fileName = angular.getObjVal(vm, 'attachment.file.name') ? vm.attachment.file.name : null;
        }

        function cleanPayload(attachment) {
            return {
                active: attachment.active || false,
                complianceItemId: complianceId,
                fileName: attachment.fileName,
                title: attachment.title
            }
        }

        function uploadAttachment(file){
            const defer = $q.defer();
            ComplianceService.attachments.upload(data => {
                defer.resolve(data);
            }, error => {
                toastr.error('Unable to upload file', error.message);
                defer.reject(error);
            }, file);
            return defer.promise;
        }

        function callAttachmentCreateApi() {
            const defer = $q.defer();
            ComplianceService.attachments.create(data => {
                $uibModalInstance.close(vm.attachment);
                defer.resolve(vm.attachment);
            }, error => {
                toastr.error('Unable to save data', error.message);
                $uibModalInstance.close(vm.attachment);
                defer.reject(error);
            }, cleanPayload(vm.attachment));
            return defer.promise;
        }

        function createNewAttachment() {
            vm.savingData = true;
            uploadAttachment(vm.attachment.file).then(data => {
                vm.attachment.fileName = data.fileName;
                callAttachmentCreateApi().then(data => {
                    vm.savingData = false;
                });
            }, error => {
                vm.savingData = false;
            });
        }

        function callAttachmentUpdateApi() {
            const defer = $q.defer();
            ComplianceService.attachments.update(data => {
                $uibModalInstance.close(vm.attachment);
                defer.resolve(vm.attachment);
            }, error => {
                toastr.error('Unable to update data', error.message);
                $uibModalInstance.close(vm.attachment);
                defer.reject(error);
            }, vm.attachment.id, cleanPayload(vm.attachment));
            return defer.promise;
        }

        function updateAttachment() {
            vm.savingData = true;
            if (vm.attachmentRaw.fileName !== attachment.fileName) {
                uploadAttachment(vm.attachment.file).then(data => {
                    callAttachmentUpdateApi().then(data => {
                        toastr.success('Successfully update!');
                        vm.savingData = false;
                    });
                }, error => {
                    toastr.error('Unable to upload file',error.message)
                    vm.savingData = false;
                });
            }else{
                callAttachmentUpdateApi().then(data => {
                    toastr.success('Successfully update!');
                    vm.savingData = false;
                });
            }
        }

        function isOriginalAttachmentDataSet() {
            return ObjectHelpersService.isObjectEmpty(vm.attachmentRaw);
        }

        function saveAttachment() {
            if (isOriginalAttachmentDataSet()) {
                createNewAttachment();
            } else {
                updateAttachment();
            }
        }

        function getInvalidForms(forms) {
            return FormHelpersService.getInvalidForms(forms);
        }

        function setFormsToSubmitted(forms) {
            FormHelpersService.setFormsToSubmitted(forms);
        }

        function onSaveButtonClickHandler(...forms) {
            setFormsToSubmitted(forms);
            const invalidForms = getInvalidForms(forms);
            if(invalidForms.length !== 0){ return false; }
            saveAttachment();
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function onCancelButtonClickHandler() {
            closeModal();
        }

        function showToActiveConfirmation() {
            vm.attachment.active = false;
            toActiveConf.getInstance().result.then(function (cond) {
                if (cond) vm.attachment.active = true;
            });
        }

        function showToInActiveConfirmation() {
            vm.attachment.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if (cond) vm.attachment.active = false;
            });
        }

        function onAttachmentActiveStatusChangedHandler(evt) {
            evt.preventDefault();
            if(vm.attachment.active){
                vm.attachment.tooltip = "Active";
                showToActiveConfirmation();
            } else {
                vm.attachment.tooltip = "InActive";
                showToInActiveConfirmation();
            }
        }

        function init() {
            vm.attachment = attachment;
            vm.attachmentRaw = angular.copy(attachment);
            console.log(vm.attachment);
        }

        init();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/compliance/modals/UploadAttachmentModalController.js